import MamWalletView from "@/views/mamWallet/MamWalletView.vue";
import MamWalletInternalTransferForm from "@/views/mamWallet/InternalTransfer/MamWalletInternalTransferForm.vue";

export default {
  MamWalletView,
  MamWalletInternalTransferForm,
};